export default {"src":"/_next/static/media/Bundle.6e3a38f5.svg","height":37,"width":36,"blurWidth":0,"blurHeight":0};